import axios from 'axios';
import cookies from 'js-cookie';

import { TOKEN_COOKIE_NAME } from '@/auth/constants';

export const getPdfById = async (id: string | number, token?: string): Promise<string> => {
	token = token ?? cookies.get(TOKEN_COOKIE_NAME);
	try {
		const { data } = await axios.get(`${process.env.HOST}/api_v1/application-signed-documents/`, {
			params: { id },
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return data;
	} catch (error) {
		console.error(error);
		throw error.response?.data ?? error.message ?? 'Ошибка при получении PDF';
	}
};
